import {
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
} from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

const CUSTOM_ICONS: { name: string; path: string }[] = [
  { name: 'file_attachment', path: 'assets/icons/file_attachment.svg' },
  { name: 'file_attachment_white', path: 'assets/icons/file_attachment_white.svg' },
];

export function provideIconConfig(): EnvironmentProviders {
  return provideEnvironmentInitializer(() => {
    const registry = inject(MatIconRegistry);
    const sanitizer = inject(DomSanitizer);

    registry.setDefaultFontSetClass('material-symbols-outlined');

    for (const icon of CUSTOM_ICONS) {
      registry.addSvgIcon(
        icon.name,
        sanitizer.bypassSecurityTrustResourceUrl(icon.path),
      );
    }
  });
}
